import * as Yup from 'yup';
import { cpfValidator } from '../../utils/CpfValidator';
import dayjs from 'dayjs';

export const InformePagamentosValidation = Yup.object({
  noCardChecked: Yup.boolean().default(false),

  numeroCartao: Yup.string().when('noCardChecked', ([noCardChecked], schema) => 
    noCardChecked 
      ? schema.notRequired() 
      : schema
        .required('Cartão inválido ou incorreto')
        .test('valid-card-number', 'Verifique se o número do cartão está correto', value => {
          return value.length === 17; 
        })

  ),

  cpf: Yup.string()
    .test('cpf-valid', 'Verifique se o CPF está correto', function (value) {
      return cpfValidator(value || '');
    })
    .required('Verifique se o CPF está correto'),

  dataNascimento: Yup.string().when('noCardChecked', ([noCardChecked], schema) => 
    noCardChecked
      ? schema
          .required('Insira uma data de nascimento válida e correta')
          .test(
            'valid-date-format',
            'Verifique se a data de nascimento está correta',
            value => {
              const parsedDate = dayjs(value, 'DD/MM/YYYY', true);
              return parsedDate.isValid();
            }
          )
          .test(
            'not-today-or-future',
            'Verifique se a data de nascimento está correta',
            value => {
              const parsedDate = dayjs(value, 'DD/MM/YYYY', true);
              return parsedDate.isValid() && parsedDate.isBefore(dayjs(), 'day');
            }
          )
      : schema.notRequired()
  ),
});
